<div class="response-actions-container">
  <shared-response-actions
    [analystRunbook]="pkg()?.response_actions?.analyst_runbook ?? ''"
    [mitigationRecommendations]="pkg()?.response_actions?.mitigation_recommendations ?? ''"
    [playbook]="pkg()?.response_actions?.playbook ?? ''"
  ></shared-response-actions>
</div>
